import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { ethers } from 'ethers';
import { getApmInternalAppInfo, getAragonOsInternalAppInfo, hasAppInfo } from './overrides/index';
import { DEFAULT_IPFS_GATEWAY } from '../params';
export function parseMetadata(name, metadata) {
  try {
    return JSON.parse(metadata);
  } catch (error) {
    throw new Error("Can't parse ".concat(name, " file, invalid JSON."));
  }
}
export function fetchMetadata(_x, _x2) {
  return _fetchMetadata.apply(this, arguments);
}

function _fetchMetadata() {
  _fetchMetadata = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(fileName, contentUri) {
    var contentHashRegEx, url, metadata;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            contentHashRegEx = contentUri.match(/ipfs:(.*)/);

            if (!contentHashRegEx) {
              _context.next = 13;
              break;
            }

            url = "".concat(DEFAULT_IPFS_GATEWAY, "/ipfs/").concat(contentHashRegEx[1], "/").concat(fileName);
            _context.prev = 3;
            _context.next = 6;
            return ethers.utils.fetchJson(url);

          case 6:
            metadata = _context.sent;
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            throw new Error("Can't fetch ".concat(url, ", failed with error: {error}."));

          case 12:
            return _context.abrupt("return", metadata);

          case 13:
            return _context.abrupt("return", {});

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
  return _fetchMetadata.apply(this, arguments);
}

export function resolveMetadata(_x3, _x4, _x5) {
  return _resolveMetadata.apply(this, arguments);
}

function _resolveMetadata() {
  _resolveMetadata = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(fileName, contentUri, metadata) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!metadata) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", parseMetadata(fileName, metadata));

          case 2:
            if (!contentUri) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", fetchMetadata(fileName, contentUri));

          case 4:
            return _context2.abrupt("return", {});

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _resolveMetadata.apply(this, arguments);
}

export function resolveManifest(_x6) {
  return _resolveManifest.apply(this, arguments);
}

function _resolveManifest() {
  _resolveManifest = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(data) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", resolveMetadata('manifest.json', data.contentUri, data.manifest));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _resolveManifest.apply(this, arguments);
}

export function resolveArtifact(_x7) {
  return _resolveArtifact.apply(this, arguments);
}

function _resolveArtifact() {
  _resolveArtifact = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(data) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!hasAppInfo(data.appId, 'apm')) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", getApmInternalAppInfo(data.appId));

          case 2:
            if (!hasAppInfo(data.appId, 'aragon')) {
              _context4.next = 4;
              break;
            }

            return _context4.abrupt("return", getAragonOsInternalAppInfo(data.appId));

          case 4:
            return _context4.abrupt("return", resolveMetadata('artifact.json', data.contentUri, data.artifact));

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _resolveArtifact.apply(this, arguments);
}